import moment from "moment";

const convertDateStr = (outputFormat) => (inputFormat) => (dateStr) => {
	return moment(dateStr, inputFormat).format(outputFormat);
};

/**
 * Coerce a date string from format DD/MM/YYYY to YYYY-MM-DD
 * @param {string} val
 */
export const coerceSlashDelimitedDate = (val) => {
	return convertDateStr("YYYY-MM-DD")("DD/MM/YYYY")(val);
};
